"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("path", {
        d: "M12.895 5.358a1.42 1.42 0 00-1.255-.754H5.376c-.536 0-1.026.296-1.271.769L2.879 7.872a.398.398 0 00-.046.192v3.297c0 .576.475 1.035 1.072 1.035h9.19c.597 0 1.072-.459 1.072-1.035V8.079a.398.398 0 00-.046-.193l-1.226-2.528zm-7.963.4a.496.496 0 01.444-.267h6.264c.183 0 .352.104.428.252l.92 1.877h-2.252a.454.454 0 00-.444.355c-.015.06-.337 1.434-1.777 1.434S6.755 8.034 6.74 7.975a.454.454 0 00-.444-.355H4.013l.919-1.863zm8.316 5.618c0 .088-.062.148-.153.148h-9.19c-.091 0-.153-.06-.153-.148V8.522h2.175c.291.769 1.057 1.79 2.573 1.79s2.282-1.036 2.573-1.79h2.175v2.854z",
        id: "channel__a"
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("mask", {
        id: "channel__b",
        fill: "currentColor",
        children: (0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#channel__a"
        })
      }), (0, _jsxRuntime.jsx)("use", {
        fill: "currentColor",
        fillRule: "nonzero",
        xlinkHref: "#channel__a"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "currentColor",
        mask: "url(#channel__b)",
        d: "M0 0h17v17H0z"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Channel.js.map